import { useState } from "react";
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import SrchResults from './stationComponents/SrchResults';
import { doLocationSearch, getStationList, getStnMetaData } from "./js/dataAccessRoutines";

let newController = null;

export default function StationSelection(props) {
  const { userParams, setUserParams, showStationSelection, setShowStationSelection, setShowGoButton } = props;
	const [ showSearchResults, setShowSearchResults ] = useState(false);
	const [ showSearchMore, setShowSearchMore ] = useState(true);
  const [ srchLocation, setSrchLocation	 ] = useState("");
  const [ srchRadius, setSrchRadius ] = useState(60.0); //miles
  const [ stationList, setStationList ] = useState([]);
  const [ srchProgress, setSrchProgress ] = useState("");
  const [ srchBbox, setSrchBbox ] = useState([]);
  const [ enteredSid, setEnteredSid ] = useState(userParams.sid); //store separately for rapid entry changes

  const handleSidChange = (e) => {
		const sid = e.currentTarget.value;
    setEnteredSid(sid);
    setShowSearchMore(sid.length === 0);
		if (sid.length >= 3) {
      setUserParams({ ...userParams, stnName: "Searching ..." });
      if (newController) {
        newController.abort();
      }
      newController = new AbortController();
			getStnMetaData(sid, userParams.product, newController.signal)
			.then(results => {
				setUserParams({ ...userParams, sid, ...results });
        setShowGoButton(true);
			})
			.catch(err => {
        console.log("getStnMetaData Error: " + err);
				setUserParams({ ...userParams, sid, stnName: "" });
			});
		} else {
			setUserParams({ ...userParams, sid, stnName: "" });
		}
	}

  const handleLocationChange = (e) => {
		const name = e.currentTarget.value;
    setStationList([]);
		setSrchLocation(name);
    setEnteredSid("");
    setUserParams({ ...userParams, sid: "", stnName: "" });
	}

  const handleLocationSearch = () => {
    setEnteredSid("")
    setShowSearchResults(true);
		setStationList([]);
		if (srchLocation.length > 0) {
			setSrchProgress("Searching for location...");
			doLocationSearch(srchLocation, srchRadius)
				.then(data => {
					setSrchProgress("Searching for stations...");
					getStationList(data.srchBbox, data.srchCenter, userParams.product)
						.then(results => { 
              setSrchProgress(""); 
              setSrchBbox(data.srchBbox);
              setStationList(results);
            })
						.catch(error =>  { 
              setSrchProgress("Metadata search error: " + error); 
            })
				})
				.catch(error => { setSrchProgress("Location search error: " + error) })
		} else {
			alert("Must specify a location");
		}
  }
  

  return (
    <Card sx={{ boxShadow: 0, backgroundColor: (theme) => theme.palette.grey[100]  }}>
      <CardHeader
        action={ 
          <IconButton 
              aria-label="expand"
              size="small"
          > 
              {showStationSelection ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />} 
          </IconButton> 
        }
        title={
          <Typography
            component="h2"
            variant="subtitle"
            sx={{ fontSize: 16 }}
          >
            {"Station Selection"}
          </Typography>
        }
        sx={{ pl: 0, pr: 0, pb: 0 }}
        onClick={() => setShowStationSelection(!showStationSelection)} 
      />

      <Collapse in={showStationSelection} timeout="auto" unmountOnExit>
        <CardContent sx={{ p: '0 !important' }}>
          <Stack direction="row" spacing={1} sx={{ pt: 2 }}>
            <TextField
              id="sid"
              label="Enter station ID"
              value={enteredSid}
              onChange={handleSidChange}
              sx={{ width: '17ch' }}
              autoFocus
            /> 
            {userParams.stnName.length > 0 &&
              <>
                <Typography sx={{ pt: 1 }}>
                  {userParams.stnName}
                </Typography>
               </>
            }
          </Stack>

          {!showSearchMore &&
            <Link 
              href="#" 
              onClick={()=>setShowSearchMore(true)} 
              variant="caption"
            >
              More search options
            </Link>
          }

          {showSearchMore &&
            <>
              <Typography sx={{ p: 1 }}>
                or
              </Typography>

              <Stack direction="row" spacing={1}>
                <TextField
                  name="srchLocation"
                  placeholder="Enter city,state or zip code"
                  label="Enter search location"
                  value={srchLocation}
                  onChange={(e) => handleLocationChange(e)}
                  sx={{ width: '25ch' }}
                  onKeyPress={(e) => { if (e.key === 'Enter') handleLocationSearch() }}
                /> 
                <TextField
                  name="srchRadius"
                  placeholder="Miles"
                  label="Search radius (miles)"
                  value={srchRadius}
                  onChange={(e) => setSrchRadius(e.currentTarget.value)}
                  onKeyPress={(e) => { if (e.key === 'Enter') handleLocationSearch() }}
                  sx={{ width: '16ch' }}
                /> 
                <Button 
                  onClick={handleLocationSearch} 
                >
                  Search
                </Button>
                {srchProgress.length > 0 &&
                  <Typography sx={{ pt: 1 }}>
                    {srchProgress}
                  </Typography>
                }
              </Stack>
              {showSearchResults &&
                <SrchResults 
                  requestBbox={srchBbox}
                  stationList={stationList} 
                  userParams={userParams}
                  setUserParams={setUserParams}
                  setShowSearchMore={setShowSearchMore}
                  setEnteredSid={setEnteredSid}
                  setShowGoButton={setShowGoButton}
                />
              }
            </>
          }
       </CardContent>
      </Collapse>
    </Card>
  )          
}